import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from 'react'
import QRCode from 'qrcode'
import No from '../../Assets/Images/Login/no.svg'
import CheckIcon from '../../Assets/Images/Login/check.png'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faSquarePen } from '@fortawesome/free-solid-svg-icons'
import { useGetCotizacionPrice } from 'Utils/Helpers/calculateAmount'
import duplicateBlue from './icons/duplicate-blue.svg'

import {
  Envelope,
  Check,
  X,
  BoxArrowUp,
  CurrencyDollar,
  Whatsapp,
} from 'react-bootstrap-icons'
import Navigation from '../../Components/Navigation'
import CircularProgress from '@mui/material/CircularProgress'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import './editarCotizacion.css'
import Modal from '@mui/material/Modal'
import MetodoEntrega from '../../Components/MetodoEntrega'
import Box from '@mui/material/Box'
import CrearCliente from '../../Views/Clientes/CrearCliente'
import { VAContext } from '../../Context/VAContext'
import RouterPrompt from '../../Components/RouterPrompt'
import {
  cotizacionUpdate,
  guardarCotizacion,
  eliminarProducto,
  modificarClienteContado,
  cotizacionPriceChangeApproval,
  mostrarDescuento,
  searchSalesDocumentDetail,
  sendEmailCotizacion,
  agregarSucursal,
  cotizacionReStart,
} from '../../redux/actions/cotizacionActions.js'
import {
  downloadPdfFuntion,
  hasChangePriceApprove,
  updateHiddenColumns,
  isGerentsStore,
  FormatedDate,
  generateColorStatus,
  validateRoles,
  validatorIsCountedCustomer,
  validatorErrorUpdate,
  valitadorODCPDF,
} from '../../Utils/functions'
import { Formatter } from 'Utils/Formatter'
import * as Yup from 'yup'
import { emptyCart } from '../../redux/actions/cartActions.js'
import { useFormik } from 'formik'
import ChangeSalesman from '../../Components/ChangeSalesman'
import FilteringTable from '../../Components/FilteringTable'
import LightTooltip from '../../Components/LightTooltip'
import ConfirmStartSalesOrder from '../../Components/SalesOrder/ConfirmStartSalesOrder'
import GenerateSalesOrder from '../../Components/SalesOrder/GenerateSalesOrder'
import CurrencyInput from 'react-currency-input-field'
import MiniLoading from 'Components/MiniLoading'
import { creditAccountsAction } from 'redux/actions/catalogActions'
import { Row } from 'react-bootstrap'
import { useFreeTaxes } from 'state/context/CotizationTaxesContext'
import {
  ROUTES,
  docHeaderStatusDescription,
  docHeaderStatusId,
  documentTypeId,
  fullfilmentIds,
  VAPermissions,
  pendingStatusDocument,
  processStatusDocument,
  closeStatusDocument,
  expiredStatusDocument,
  colorsStatus,
  customerTypeAllowedRoles,
  EMPTY_GUID,
  regexCellPhone,
} from 'Utils/constants'
import { t } from 'i18next'
import GenericModal from 'Components/GenericModal'
import RelationalDocLabel from 'Components/RelationalDocLabel'
import MarginText from 'Components/MarginText/MarginText'
import { useCheckFinalPrice } from 'Components/ActionTable/hooks/useCheckFinalPrice'
import Loading from 'Components/Loading'
import useValidatePermission from 'Hooks/useValidatePermission'
import {
  GetApprovalSalesOrder,
  getOdcDocument,
  searchSalesDocumentDetailService,
} from 'redux/services/cotizacionServices'
import { getPriceInventoryGeneral } from 'redux/actions/priceProductsAction'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import ToolTipAmount from 'Components/ToolTipAmount/ToolTipAmount'
import { DownloadButton } from './components/DownloadButton'
import DeliveryDateLabel from 'Components/DeliveryDateLabel/DeliveryDateLabel'
import ModalQuoteCloneAlert from 'Components/ModalQuoteCloneAlert/ModalQuoteCloneAler'
import store from 'redux/store'
import { useCotizationLogic } from 'Views/VentaPorProducto/hooks/useCotizationLogic'
import { isCostExemptProduct } from 'Utils/functions'
import { updateSellerIfApplicable } from 'Utils/Helpers/updateSellerIfApplicable'
import { AdditionalServiceDetailsEditor } from 'Views/GenerarCotizacion/components/AdditionalServiceDetailsEditor/AdditionalServiceDetailsEditor'
import { searchInfoAddressId } from 'redux/actions/clientsActions'
import Tints from 'Hooks/useTintsController/Tints'
import { useMarginVisibility } from 'Hooks/useMarginVisibility'
import { getMarginColumn } from 'Components/FilteringTable/columns/MarginColumn'
import PaymentMethodModal from 'Components/PaymentMethodModal'
import PaymentMethodSection from 'Components/PaymentMethodSection'
import YappyPaymentConfirmationModal from 'Components/YappyPaymentConfirmationModal'
import YappyPaymentInfo from 'Components/YappyPaymentInfo'
import { ListPaymentTypes } from 'Views/OrdenDeVenta/components/ListPaymentType'
import { getYappyPayments } from 'Utils/yappyPayments'
import { validateQuoteForYappyPayment } from 'Utils/paymentValidations'
import {
  PAYMENT_METHOD_IDS,
  PAYMENT_OPTIONS,
} from 'Components/PaymentMethodModal/constants/paymentOptions'
import { createYappyPaymentLink } from 'Api/services/paymentServices'
import { getPaymentMethods } from 'Api/paymentConfig/paymentConfig.services'
import { createAbortableRequest } from 'Views/Settings/YappyConfig/utils/request.utils'

function TopButtons({
  pdf,
  sendEmail,
  needToBeAuth,
  handlePriceChange,
  lines,
  hasProducts,
  companyId,
}) {
  const isCustomerUser = useSelector(state => state.login.isCustomer)
  const loginInfo = useSelector(state => state.login?.user?.AuthenticationInfo)
  const wareHouseID = useSelector(
    state => state.login?.user?.CustomerInfo.Warehouses
  )

  const quotationWarehouseId = useSelector(
    state => state.cotizacion.QuoteHeader.WarehouseId
  )

  const isGerentsStoreUsers = isGerentsStore(loginInfo.UserRoles)
  const aproveDiscount = useValidatePermission(VAPermissions.aproveDiscount)
  const isWareHouse = wareHouseID.some(
    w => w.WarehouseId === quotationWarehouseId
  )

  const isSuperSuperUser =
    aproveDiscount && !isGerentsStoreUsers
      ? true
      : aproveDiscount && isWareHouse

  const isComercialSellerConstruction =
    validateRoles(
      loginInfo.UserRoles,
      customerTypeAllowedRoles.comercialSellerConst
    ) ||
    validateRoles(
      loginInfo.UserRoles,
      customerTypeAllowedRoles.comercialSellerConstruction
    )
  const isComercialSellerDistribution =
    validateRoles(
      loginInfo.UserRoles,
      customerTypeAllowedRoles.comercialSellerDist
    ) ||
    validateRoles(
      loginInfo.UserRoles,
      customerTypeAllowedRoles.comercialSellerDistribution
    )

  return (
    <div
      className="top-action-table-buttons"
      data-testid="container-top-action-buttons">
      <button
        data-testid="btn-price-change"
        style={{
          backgroundColor:
            needToBeAuth &&
            isSuperSuperUser &&
            !(isComercialSellerConstruction || isComercialSellerDistribution) &&
            hasProducts
              ? '#FF2A40'
              : 'gray',
          color: needToBeAuth && isSuperSuperUser ? '#FFFFFF' : 'lightgray',
        }}
        disabled={
          isCustomerUser ||
          !(needToBeAuth && isSuperSuperUser) ||
          !hasProducts ||
          isComercialSellerConstruction ||
          isComercialSellerDistribution
        }
        onClick={() => handlePriceChange()}>
        <CurrencyDollar />
      </button>
      <DownloadButton
        disabled={isCustomerUser}
        download={pdf}
        companyId={companyId}
      />
      <button
        data-testid="btn-send-email"
        onClick={sendEmail}
        disabled={isCustomerUser}
        style={{
          backgroundColor: '#12C1F8',
          color: '#FFFFFF',
        }}>
        <Envelope />
      </button>
      <button
        data-testid="btn-whatsapp"
        style={{
          backgroundColor: '#4ECC5C',
          color: '#FFFFFF',
        }}
        disabled={isCustomerUser}
        onClick={() => {
          pdf(true)
        }}>
        <Whatsapp />
      </button>
    </div>
  )
}

function SubtotalNumbers() {
  const channel = new BroadcastChannel('customer_display')
  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const { freeTaxes, isChanged } = useFreeTaxes()

  // Price = effective unit price (all discounts applied), DiscountAmount = per-unit total discount
  const computedSubTotal = (useSelectorDetalle?.Lines || []).reduce(
    (sum, item) =>
      sum +
      ((item.Price || 0) + (item.DiscountAmount || 0)) * (item.Quantity || 0),
    0
  )
  const totalDiscountToShow = (useSelectorDetalle?.Lines || []).reduce(
    (sum, item) => sum + (item.DiscountAmount || 0) * (item.Quantity || 0),
    0
  )

  let tax = useSelectorDetalle?.Tax
  let amountWithTax = useSelectorDetalle?.AmountWithTax

  if (!freeTaxes && isChanged && useSelectorDetalle?.Lines.length > 0) {
    tax = 0
    useSelectorDetalle?.Lines.forEach(item => {
      // Price already has all discounts applied
      const netAmount = item.Price * item.Quantity
      const subtotalLine = Number(
        Formatter.Money(netAmount, {
          withFormat: false,
          rounded: true,
          decimalPrecision: 2,
        })
      )

      const taxLine = subtotalLine * item.TaxCategoryValue

      tax += taxLine
      amountWithTax = Number(
        Formatter.Money(useSelectorDetalle?.Amount + tax, {
          withFormat: false,
        })
      )
    })
  }
  channel.postMessage({
    isDetailQuote: true,
    quoteData: useSelectorDetalle,
    isLoadingDetailQuote: false,
    isSearchProducts: false,
    addedProduct: false,
  })

  return (
    <div className="money-data-totals" data-testid="container-subtotal-numbers">
      <p>
        $
        {showDiscountOption
          ? Formatter.Money(computedSubTotal, {
              decimalPrecision: 2,
            })
          : Formatter.Money(useSelectorDetalle?.Amount)}
      </p>
      {showDiscountOption && (
        <p>${Formatter.Money(totalDiscountToShow, { decimalPrecision: 2 })}</p>
      )}
      {!freeTaxes && <ToolTipAmount amount={tax} isMargin />}
      {freeTaxes && showDiscountOption ? (
        <ToolTipAmount amount={useSelectorDetalle?.Amount} isMargin />
      ) : freeTaxes && !showDiscountOption ? (
        <ToolTipAmount amount={useSelectorDetalle?.Amount} isMargin />
      ) : (
        <ToolTipAmount amount={amountWithTax} isMargin />
      )}
    </div>
  )
}

function SubtotalText() {
  const showDiscountOption = useSelector(
    state => state.cotizacion.QuoteHeader.ShowDiscountOption
  )
  const { freeTaxes } = useFreeTaxes()
  return (
    <div className="money-data-text" data-testid="container-subtotal-text">
      <p>Sub Total</p>
      {showDiscountOption ? <p>Descuento</p> : null}
      {!freeTaxes && <p style={{ color: 'black' }}>ITBMS</p>}
      <p>Total</p>
    </div>
  )
}

function EditarCotizacion(props) {
  const isCustomer = useSelector(state => state.login.isCustomer)
  const { getCotizacionPrices } = useGetCotizacionPrice()
  const { checkFinalPrice } = useCheckFinalPrice()

  const isCustomerUser = useSelector(state => state.login.isCustomer)
  const user = useSelector(state => state.login.user)
  const coti = useSelector(state => state?.cotizacion?.QuoteHeader)
  const userId = useSelector(
    state => state?.login?.user?.CustomerInfo?.CustomerId
  )
  const userName = useSelector(
    state => state?.login?.user?.CustomerInfo?.FullName
  )
  const isComercialSellerConstruction =
    validateRoles(
      user?.AuthenticationInfo?.UserRoles,
      customerTypeAllowedRoles.comercialSellerConst
    ) ||
    validateRoles(
      user?.AuthenticationInfo?.UserRoles,
      customerTypeAllowedRoles.comercialSellerConstruction
    )
  const isComercialSellerDistribution =
    validateRoles(
      user?.AuthenticationInfo?.UserRoles,
      customerTypeAllowedRoles.comercialSellerDist
    ) ||
    validateRoles(
      user?.AuthenticationInfo?.UserRoles,
      customerTypeAllowedRoles.comercialSellerDistribution
    )

  const [lines, setLines] = useState(null)
  const [addressInfo, setAddressInfo] = useState(coti)
  const [warehouseInfo, setWarehouseInfo] = useState(coti)
  const cotizacionFinal = useSelector(state => state?.cotizacion)
  const [cotizacionInicial, setCotizacionInicial] = useState(null)
  const [activeButton, setActiveButton] = useState(false)

  const useSelectorDetalle = useSelector(state => state.cotizacion.QuoteHeader)

  const showDiscountOption = useSelectorDetalle.ShowDiscountOption
  const fulfillmentPlan =
    (useSelectorDetalle.Lines || []).filter(
      item => item.FulfillmentPlanDescription
    )?.[0]?.FulfillmentPlanDescription ?? null

  const [loading, setLoading] = useState(false)
  const [showFailMessageModal, setShowFailMessageModal] = useState(false)

  const userInfo = useSelector(state => state.login.user)

  const [showHasChangesModal, setShowHasChangesModal] = useState(false)
  const [isEditLoading, setIsEditLoading] = useState(false)
  const [date, setDate] = useState(null)
  const { id, header } = useParams()
  const [cotizacion, setCotizacion] = useState(null)
  const [qrSource, setQrSource] = useState('')
  const [showModalEditClient, setShowModalEditClient] = useState(false)
  const [showModalEditDelivery, setShowModalEditDelivery] = useState(false)
  const [showModalEliminarProduct, setShowModalEliminarProduct] =
    useState(false)
  const [showMessageEmail, setMessageEmail] = useState(false)
  const [editClienteContado, setEditClienteContado] = useState(null)
  const [clienteTemp, setClienteTemp] = useState({
    name: '',
    email: '',
    telephone: '',
  })

  const [errorCustomerCounted, setErrorCustomerCounted] = useState({
    names: '',
    email: '',
    phone: '',
  })

  const [, setDireccion] = useState(null) // Establece si hay direccion o hay retiro en sucursal
  const [customerId, setCustomerId] = useState(null) // Establece si hay direccion o hay retiro en sucursal
  const [isAuthorized, setIsAuthorized] = useState(null)
  const [loadingSendEmail, setLoadingSendEmail] = useState(false)
  const [promisedDate, setPromisedDate] = useState(coti?.PromisedDate)

  // Guardar valores originales del método de entrega para restaurar si se cancela
  const originalDeliveryDataRef = React.useRef(null)

  // Ref para evitar actualizaciones de estado cuando el componente ya no está montado
  const isMountedRef = useRef(true)

  const [comment, setComment] = useState('')
  const [change, setChange] = useState(false)
  const [, setEmailLoading] = useState(false)
  const [hasButtons, setHasButtons] = useState(false)
  const [showModalEmail, setShowModalEmail] = useState(false)
  const [isDeletingProduct, setIsDeletingProduct] = useState(false)
  const [showModalConfirmStartSalesOrder, setShowModalConfirmStartSalesOrder] =
    useState(false)
  const [confirmStartSalesOrder, setConfirmStartSalesOrder] = useState(false)
  const [showModalGenerateSalesOrder, setShowModalGenerateSalesOrder] =
    useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [showModalPriceChangeApproval, setShowModalPriceChangeApproval] =
    useState(false)
  const [productsChanged, setProductsChanged] = useState([])
  const [email, setEmail] = useState('')

  const { selectClient } = useContext(VAContext)
  const [agent, setAgent] = useState({})

  const [isModal, setIsModal] = useState(false)
  const [needToBeAuth, setNeedToBeAuth] = useState(false)

  const [indexProductCurrent, setIndexProductCurrent] = useState(0)
  const [newPriceProductCurrent, setNewPriceProductCurrent] = useState(null)

  const [showModalApprovedPrice, setShowModalApprovedPrice] = useState(false)
  const [showModalRejectedPrice, setShowModalRejectedPrice] = useState(false)

  const [isCreate, setIsCreate] = useState(false)
  const [odvCreditAccount, setOdvCreditAccount] = useState(null)

  const isSaveButtonAvailable = cotizacionFinal?.QuoteHeader?.Lines?.length > 0

  const { isRedirect } = useSelector(state => state.sellOrder)

  // Estados para clonación
  const [showModalClone, setshowModalClone] = useState(false)

  const [hiddenColumns, setHiddenColumns] = useState([])
  const [hiddenColumnsInitial, setHiddenColumnsInitial] = useState([])
  const [updatedColumnsVisibility, setUpdatedColumnsVisibility] =
    useState(false)

  const canChangeSeller = useValidatePermission(VAPermissions.changeSeller)
  const canSelectPaymentMethod =
    useValidatePermission(VAPermissions.selectPaymentMethod) &&
    cotizacion?.DocHeaderStatusAction === 'OPEN'
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
  const [isYappyConfirmOpen, setIsYappyConfirmOpen] = useState(false)
  const [yappyConfirmData, setYappyConfirmData] = useState(null)
  const [yappyEnabled, setYappyEnabled] = useState(false)
  const [isCheckingYappy, setIsCheckingYappy] = useState(false)
  const [localYappyPayment, setLocalYappyPayment] = useState(null)
  const [isPaymentAmountError, setIsPaymentAmountError] = useState(false)
  const [paymentAmountErrorMsg, setPaymentAmountErrorMsg] = useState({
    message: '',
    status: '',
  })

  const { isInstallationService } = useCotizationLogic()

  const fullfilmentDescription = fullfilmentIds?.homeDelivery?.fulfillmentPlanId

  const viewProductMargin = useValidatePermission(VAPermissions.seeMargenProd)
  const { showAll, toggleAll, toggleRow, isRowVisible } = useMarginVisibility(
    coti?.Lines?.length || 0
  )

  const columns = useMemo(() => {
    const cols = [
      {
        Header: 'Referencia',
        accessor: 'Referencia',
        hideEnabled: true,
      },
      {
        Header: 'Número de Parte',
        accessor: 'Número de Parte',
        hideEnabled: true,
      },
      {
        Header: 'Descripción',
        accessor: 'Descripción',
      },
      {
        Header: 'Imagen',
        accessor: 'Imagen',
        hideEnabled: true,
      },
      {
        Header: 'Marca',
        accessor: 'Marca',
        hideEnabled: true,
      },
      {
        Header: 'País de Origen',
        accessor: 'País de Origen',
        hideEnabled: true,
      },
      {
        Header: 'Cantidad',
        accessor: 'Cantidad',
      },
      {
        Header: 'Precio Unitario',
        accessor: 'Precio Unitario',
      },
      {
        Header: 'Descuento',
        accessor: 'Descuento',
        hideEnabled: true,
      },
      {
        Header: 'Precio Total',
        accessor: 'Precio Total',
        ...(!viewProductMargin && { Footer: <SubtotalText /> }),
      },
    ]

    if (viewProductMargin) {
      cols.push(
        getMarginColumn({
          showAll,
          toggleAll,
          toggleRow,
          isRowVisible,
          footer: <SubtotalText />,
        })
      )
    }

    cols.push({
      Header: 'Acciones',
      accessor: 'Acciones',
      Footer: <SubtotalNumbers />,
    })

    return cols
  }, [viewProductMargin, showAll, isRowVisible])

  const [open, setOpen] = useState(false)
  const [saveIsLoading, setSaveIsLoading] = useState(false)

  const closeAllModals = () => {
    setShowModalEditDelivery(false)
    setShowModalEditClient(false)
  }

  const location = window.location.href
  const useSelectorQuoteObject = useSelector(state => state.cotizacion)
  const [visibleIcons, setVisibleIcons] = useState(false)

  const checkApprovalState = async DocHeaderId => {
    try {
      const data = await GetApprovalSalesOrder(DocHeaderId)
      setVisibleIcons(data?.data?.Data?.[0]?.Approval)
    } catch (error) {
      console.log(error)
    }
  }

  const CompanyId = useSelector(state => state?.company?.CompanyId)
  const warehouse = useSelector(state => state.company.WarehouseId)
  const CompanyCode = useSelector(state => state?.company?.CompanyCode)

  useEffect(() => {
    if (!canSelectPaymentMethod || !isPaymentModalOpen || !CompanyId)
      return undefined

    const { requestConfig, isMounted, abort } = createAbortableRequest()
    setIsCheckingYappy(true)
    setYappyEnabled(false)

    getPaymentMethods(CompanyId, requestConfig)
      .then(({ data }) => {
        if (!isMounted()) return
        const methods = data?.Data ?? []
        const yappy = methods.find(
          m => m.PaymentTypeId === PAYMENT_METHOD_IDS.YAPPY
        )
        setYappyEnabled(yappy?.IsEnabled === true)
      })
      .catch(() => {
        if (!isMounted()) return
        setYappyEnabled(false)
      })
      .finally(() => {
        if (!isMounted()) return
        setIsCheckingYappy(false)
      })

    return abort
  }, [canSelectPaymentMethod, isPaymentModalOpen, CompanyId])

  const [dataODC, setDataODC] = useState(false)

  const [costRealTime, setCostRealTime] = useState([])

  const [isErrorAddressModal, setIsErrorAddressModal] = useState(false)
  const [messageAddressModal, setMessageAddressModal] = useState({
    message: '',
    status: '',
  })

  useEffect(() => {}, [
    location,
    useSelectorQuoteObject?.QuoteHeader?.RelationDoc?.[0]?.DocHeaderId,
  ])

  const showButtons = () => {
    if (
      cotizacion?.DocHeaderStatusAction === 'OPEN' ||
      cotizacion?.DocHeaderStatusAction === 'DRAFT'
    ) {
      setHasButtons('block')
    } else {
      setHasButtons('none')
    }
  }
  const stateInitial = {
    email: '',
  }

  const approvedLines = lines => {
    const approved = lines.every(item => {
      const bothNull =
        item.NegotiatedReasonId === null && item.AuthorizedPriceBy === null
      const bothNotNull =
        item.NegotiatedReasonId !== null && item.AuthorizedPriceBy !== null
      return bothNull || bothNotNull
    })
    setIsAuthorized(approved)
  }

  const setTableData = data => {
    if (!data) return []
    const products = data.map(product => {
      return {
        ...product,
        Referencia: product?.SystemCode,
        Descripción: (
          <>
            <div>{product?.ProductName}</div>
            {product?.ColorVariants && (
              <Tints key={product?.ProductId} tints={product?.ColorVariants} />
            )}
          </>
        ),
        Imagen: product?.DefaultProductPicture || NoImage,
        Marca: product?.Brand,
        'País de Origen': 'Panamá',
        Cantidad: product?.Quantity,
        'Precio Unitario': showDiscountOption
          ? (product?.Price ?? 0) + (product?.DiscountAmount || 0)
          : product?.Price ?? 0,
        Descuento: product?.DiscountAmount || 0,
        'Precio Total': product?.Amount ?? product?.Price * product?.Quantity,
        'Número de Parte': product?.PartNumber || 'Desconocido',
        // Margen: 1,
      }
    })
    return products
  }

  const productsData = useMemo(
    () => setTableData(coti?.Lines),
    [coti?.Lines, showDiscountOption]
  )

  useEffect(() => {
    setLines(coti?.Lines)
    setEmail(coti?.EmailAddress || coti?.CustomerEmail)
    approvedLines(coti?.Lines)
    setClienteTemp({
      name: coti.CustomerNameDocument,
      email: coti.CustomerEmail || coti.EmailAddress,
      telephone: coti.Telephone_Number || coti.Cellphone_Number,
    })

    setAddressInfo({
      ...coti,
      Address_AddressId:
        addressInfo?.Address_AddressId || coti?.Address_AddressId,
      QuoteAddressIdCounted:
        addressInfo?.QuoteAddressIdCounted || coti?.Address_AddressId,
      PhoneNumber: addressInfo?.PhoneNumber,
    })
    setWarehouseInfo(coti)
  }, [coti])

  const formik = useFormik({
    initialValues: stateInitial,
    validationSchema: Yup.object({
      email: Yup.string()
        .required('Por favor, introduzca un email válido')
        .nullable(),
    }),
    validate: values => {
      const errors = {}

      return errors
    },
    onSubmit: values => {
      sendEmail()
    },
  })

  const handleModal = () => {
    setShowModalEditClient(!showModalEditClient)
    clientToEdit(customerId)
  }

  const clientToEdit = customerId => {
    selectClient(customerId, false, true, true)
  }

  const handleDelivery = () => {
    // Limpiar valores originales ya que el usuario confirmó los cambios
    originalDeliveryDataRef.current = null
    setShowModalEditDelivery(false)
  }

  const handleClienteContado = () => {
    setEditClienteContado(!editClienteContado)
    setErrorCustomerCounted({
      names: '',
      email: '',
      phone: '',
    })
    setClienteTemp({
      name: cotizacion.CustomerNameDocument,
      email: cotizacion.CustomerEmail || cotizacion.EmailAddress,
      telephone: cotizacion.Telephone_Number || cotizacion.Cellphone_Number,
    })
  }

  const validationError = e => {
    e.preventDefault()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const names = clienteTemp.name || cotizacion.CustomerNameDocument
    const email =
      clienteTemp.email || cotizacion.EmailAddress || cotizacion.CustomerEmail

    const phone =
      clienteTemp.telephone ||
      cotizacion.Cellphone_Number ||
      cotizacion.Telephone_Number

    const newErrorState = {
      names: names.trim() === '' ? 'customer.CustomerCounted.RequiredCamp' : '',
      email:
        email && !emailRegex.test(email)
          ? 'customer.CustomerCounted.invalidEmail'
          : '',
      phone:
        phone && !regexCellPhone.test(phone)
          ? 'customer.CustomerCounted.telephoneDigits'
          : '',
    }

    setErrorCustomerCounted(newErrorState)

    const hasErrors = Object.values(newErrorState).some(error => error)

    if (!hasErrors) {
      modifyCliente()
    }
  }

  const modifyCliente = () => {
    const newEmail = clienteTemp.email ?? ''
    const newTelephone = clienteTemp.telephone ?? ''
    const payload = {
      ...cotizacion,
      CustomerNameDocument: clienteTemp.name || cotizacion.CustomerNameDocument,
      CustomerEmail: newEmail,
      EmailAddress: newEmail,
      Telephone: newTelephone,
      Telephone_Number: newTelephone,
      Cellphone_Number: newTelephone,
    }
    setCotizacion(payload)
    dispatch(modificarClienteContado(payload))
    setEditClienteContado(false)
  }

  const openPriceChangeModal = () => {
    setIndexProductCurrent(0)
    setShowModalPriceChangeApproval(true)
  }
  const { freeTaxes, setFreeTaxes } = useFreeTaxes()

  const channel = new BroadcastChannel('customer_display')
  const fetchCotizacion = async () => {
    setLoading(true)
    const requestedAt = Date.now()
    await dispatch(emptyCart())
    channel.postMessage({
      addedProduct: false,
      isDetailQuote: true,
      isLoadingDetailQuote: true,
      isSearchProducts: false,
    })

    const payload = {
      DocumentTypeId: documentTypeId.QUOTATION,
      DocumentHeaderId: header,
      DocumentNumber: id,
      PageNumber: 1,
      PageSize: 1,
    }
    const { Data } = await dispatch(searchSalesDocumentDetail(payload))
    let allData = Data

    const isCountedCustomer = validatorIsCountedCustomer(allData)
    if (Data && Data?.CompanyName) {
      channel.postMessage({
        isDetailQuote: true,
        isLoadingDetailQuote: true,
        isSearchProducts: false,
        addedProduct: false,
      })
      if (location.includes('editar_cotizacion')) {
        if (
          allData?.QuoteAddressId &&
          isCountedCustomer &&
          showModalEditDelivery
        ) {
          const responseAddressInfo = await dispatch(
            searchInfoAddressId(allData?.QuoteAddressId)
          )
          setAddressInfo({
            PhoneNumber: responseAddressInfo?.[0]?.PhoneNumber,
            Address_AddressId: allData?.QuoteAddressId,
            QuoteAddressIdCounted: allData?.QuoteAddressId,
          })
          const warehouse = {
            ...allData,
            Lines: allData?.Lines?.map(prod => {
              return {
                ...prod,
                WarehouseId: null,
                WarehouseDescription: null,
                WarehouseAddress: null,
                WarehouseCode: null,
              }
            }),
          }

          setWarehouseInfo({
            ...warehouseInfo,
            warehouse,
          })
        } else if (Data?.Lines[0]?.WarehouseId) {
          const warehouse = {
            ...allData,
            Lines: allData?.Lines?.map(prod => {
              return {
                ...prod,
                WarehouseId: Data?.Lines[0]?.WarehouseId,
                WarehouseDescription: Data?.Lines[0]?.WarehouseDescription,
                WarehouseAddress: Data?.Lines[0]?.WarehouseAddress,
                WarehouseCode: Data?.Lines[0]?.WarehouseCode,
                WarehouseName: Data?.Lines[0]?.WarehouseName,
                Description: Data?.Lines[0]?.WarehouseDescription,
              }
            }),
          }
          setAddressInfo(warehouse)
          dispatch(agregarSucursal(warehouse))
        }
        const hasODC = Data?.RelationDoc?.find(
          doc => doc.DocumentTypeId === documentTypeId.ODC
        )
        const ODV = Data?.RelationDoc?.find(
          doc =>
            doc?.DocumentNumber.includes('ODV') ||
            doc?.DocumentTypeId?.toLowerCase().includes(
              documentTypeId?.ODV?.toLowerCase()
            )
        )
        if (hasODC) {
          const response = await valitadorODCPDF(ODV)
          setDataODC(response)
        }
        setFreeTaxes(!!Data?.TaxExempt)
        const odvDocHeaderId = ODV?.DocHeaderId
        if (odvDocHeaderId) {
          await checkApprovalState(odvDocHeaderId)
          const {
            data: { Data: odvProducts },
          } = await searchSalesDocumentDetailService({
            DocumentTypeId: documentTypeId.ODV,
            DocumentHeaderId: odvDocHeaderId,
            DocumentNumber: null,
            PageNumber: 1,
            PageSize: 1,
          })
          if (
            odvProducts?.CreditAccountId &&
            odvProducts.CreditAccountId !== EMPTY_GUID
          ) {
            setOdvCreditAccount({
              CreditAccountId: odvProducts.CreditAccountId,
              CreditAccountNumber: odvProducts.CreditAccountNumber,
              Description: odvProducts.CreditAccountNumber,
            })
          }
          const allDataLines = allData?.Lines?.map(prod => {
            const odvProduct = odvProducts?.Lines?.find(
              odvProd => odvProd.ProductId === prod.ProductId
            )
            const notDeliveredByOdv = odvProduct?.QtyDelivered === 0
            const maxDiscount =
              odvProduct?.FinalPrices?.[1]?.FinalPrice ||
              prod?.FinalPrices?.[1]?.FinalPrice ||
              odvProduct?.FinalPrice
            const negativeMarginProds = odvProduct?.Price < maxDiscount
            return {
              ...prod,
              Sku: prod?.SystemCode || prod.Sku,
              notDeliveredByOdv,
              negativeMarginProds,
            }
          })
          allData = {
            ...allData,
            Lines: allDataLines,
          }
        } else {
          allData = {
            ...allData,
            Lines: allData?.Lines?.map(prod => {
              return {
                ...prod,
                Sku: prod?.SystemCode || prod.Sku,
                notDeliveredByOdv: true,
              }
            }),
          }
        }
        // Solo actualizar si el componente sigue montado
        if (!isMountedRef.current) return
        setCotizacion(allData)

        // Sincronizar estados locales ANTES de actualizar Redux
        // para evitar que el useEffect de validación detecte cambios falsos
        setAgent({
          SalesAgentFullName: allData.SalesAgentFullName,
          SalesAgentId: allData.SalesAgentId,
          SalesAgentNumberId: allData.SalesAgentNumberId,
          SalesAgentRoleDescription: allData.SalesAgentRoleDescription,
        })
        setCustomerId(allData.CustomerId)
        setComment(allData?.Comment)
        setPromisedDate(allData?.PromisedDate)
        setDate(new Date(allData?.DocumentDate))

        // Actualizar Redux después de sincronizar estados locales
        dispatch(
          cotizacionUpdate({
            data: allData,
            QuoteHeaderId: header,
            requestedAt,
          })
        )

        // Guardar cotizacionInicial directamente con allData para evitar desincronización
        setCotizacionInicial({
          DocumentTypeId: documentTypeId.QUOTATION,
          QuoteHeader: { QuoteHeaderId: header, ...allData },
        })
      }
      setNeedToBeAuth(allData?.NegotiatedReasonId)
      if (!isCountedCustomer) {
        dispatch(
          creditAccountsAction({
            customerId: allData?.CustomerId,
            companyId: allData?.CompanyId,
          })
        )
      }
    } else {
      throw new Error(allData)
    }
  }

  const downloadPdf = async (Whatsapp = false, docType, isCatalog) => {
    const odvRelated = cotizacion?.RelationDoc?.find(
      doc => doc?.DocumentTypeId === documentTypeId.ODV
    )
    if (docType === documentTypeId.ODC && odvRelated?.DocumentTypeId) {
      const odcDocument = await getOdcDocument({
        documentTypeId: odvRelated.DocumentTypeId,
        documentId: odvRelated.DocHeaderId,
      })
      const pdfUrl = odcDocument?.data?.Data?.find(
        item => item?.DocumentUrl !== null
      )?.DocumentUrl
      if (pdfUrl) {
        return window.open(pdfUrl, '_blank', 'noopener,noreferrer')
      }
    }
    await downloadPdfFuntion(
      Whatsapp,
      header,
      dispatch,
      setShowFailMessageModal,
      docType,
      coti.IsCatalog
    )
  }

  const sendEmail = async () => {
    const isCatalog = coti?.IsCatalog
    formik.setErrors({})
    if (formik.values.email === '') {
      setShowModalEmail(true)
      return
    }
    setEmailLoading(true)
    const payload = {
      DocumentTypeId: isCatalog
        ? documentTypeId.CATALOG
        : documentTypeId.QUOTATION,
      DocHeaderId: header,
      DocumentNumber: id,
      Email: formik.values.email,
    }
    setLoadingSendEmail(true)
    const Data = await dispatch(sendEmailCotizacion(payload, setEmailLoading))
    if (!Data && !Data?.PDFResponse) {
      throw new Error(Data)
    } else {
      setMessageEmail(true)
      setTimeout(() => {
        setMessageEmail(false)
        setEmailLoading(false)
        formik.setValues({ email: '' })
        setShowModalEmail(false)
        setMessageEmail(false)
      }, 3000)
    }
    setLoadingSendEmail(false)
  }

  const setQr = () => {
    QRCode.toDataURL(id)
      .then(response => setQrSource(response))
      .catch(err => console.error(err))
  }

  const handleCartPopulation = async () => {
    setIsEditLoading(true)
    try {
      const lineProducts = cotizacion?.Lines?.map(prod => {
        const visitPerUnit =
          prod.VisitDiscountAmount && prod.Quantity
            ? Math.ceil((prod.VisitDiscountAmount / prod.Quantity) * 10000) /
              10000
            : 0
        return {
          ...prod,
          Price: parseFloat((prod.Price + visitPerUnit).toFixed(2)),
          hasDiscount: prod.BasePrice > prod.Price,
          qty: prod.Quantity,
        }
      })

      await checkFinalPrice({
        prods: lineProducts,
        customerId: cotizacion.CustomerId,
      })
    } catch (error) {
      console.error(error)
    } finally {
      setIsEditLoading(false)
      history.push(`${ROUTES.editQuoteHeaderId}${header}/${id}/edit_cart`)
    }
  }

  const handleCartEdit = async (product, index) => {
    const parsedIndex = parseInt(index)
    dispatch(emptyCart())
    dispatch(eliminarProducto(parsedIndex))
    setShowModalEliminarProduct(true)

    const updatedQuote = store.getState().cotizacion.QuoteHeader
    getCotizacionPrices({ quote: updatedQuote, freeTaxes, setCotizacion })
    setIsDeletingProduct(true)
    setTimeout(() => {
      setShowModalEliminarProduct(false)
    }, 1000)
  }

  // Resetear cotizacionInicial cuando cambia la cotización
  useEffect(() => {
    setCotizacionInicial(null)
    setActiveButton(false)
  }, [header])

  useEffect(() => {
    isMountedRef.current = true
    const storedQuoteId = coti?.QuoteHeaderId || coti?.DocHeaderId
    const isSameStoredQuote =
      storedQuoteId === header && String(coti?.DocumentNumber) === String(id)

    if (!isSameStoredQuote) {
      dispatch(cotizacionReStart())
      setLocalYappyPayment(null)
    }
    fetchCotizacion()

    return () => {
      isMountedRef.current = false
    }
  }, [header, id])

  useEffect(() => {
    if ((cotizacion?.Payments?.length ?? 0) > 0 && localYappyPayment != null) {
      setLocalYappyPayment(null)
    }
  }, [cotizacion?.Payments])

  // Guardar cotizacionInicial después de que Redux se actualice (fallback)
  useEffect(() => {
    if (
      !cotizacionInicial &&
      cotizacionFinal?.QuoteHeader?.QuoteHeaderId &&
      cotizacionFinal?.QuoteHeader?.QuoteHeaderId !==
        '00000000-0000-0000-0000-000000000000'
    ) {
      setCotizacionInicial({
        DocumentTypeId: cotizacionFinal.DocumentTypeId,
        QuoteHeader: { ...cotizacionFinal.QuoteHeader },
      })
    }
  }, [cotizacionFinal, cotizacionInicial])

  useEffect(() => {
    hiddenColumnDiscount(true)
  }, [cotizacion?.DocHeaderStatusAction])

  useEffect(() => {
    setQr()
    if (lines) {
      checkIfAuthorized()
      const productsWithPriceChange = lines.filter(
        line =>
          line?.NegotiatedReasonId &&
          line?.NegotiatedReasonId !== null &&
          line.NegotiatedReasonId !== ''
      )
      // remove approved products
      const productsWithPriceChangeFiltered = productsWithPriceChange.filter(
        line => line.AuthorizedPriceByName === null
      )
      setProductsChanged(productsWithPriceChangeFiltered)
    }
  }, [lines])

  useEffect(() => {
    showButtons()
  }, [cotizacion])

  useMemo(() => {
    if (isRedirect) {
      setIsCreate(true)
    } else {
      setIsCreate(false)
    }
    dispatch({
      type: 'SET_IS_REDIRECT',
      payload: false,
    })
  }, [])

  const saveCotizacion = async () => {
    setOpen(true)

    const payload = {
      id: docHeaderStatusId.open,
      name: 'Guardar como documento',
      value: 'Abierto',
      valueState: 'OPEN',
      disabled: !isAuthorized,
    }
    await saveType(payload)
    setChange(false)
  }

  const checkIfAuthorized = () => {
    // const priceApproved = lines.map(line => {
    //   if (line.AuthorizedPriceBy) {
    //     setPriceChangeApproval(true)
    //   }
    // })
  }

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const hiddenColumnDiscount = useCallback(
    bool => {
      if (cotizacion?.DocHeaderStatusAction) {
        dispatch(mostrarDescuento(bool))
      }
    },
    [cotizacion?.DocHeaderStatusAction, dispatch]
  )

  const hasOdv = coti?.RelationDoc?.find(
    doc =>
      doc?.DocumentNumber?.includes('ODV') ||
      doc?.DocumentTypeId?.toLowerCase()?.includes(
        documentTypeId?.ODV?.toLowerCase()
      )
  )

  const [hasProdWithNoCost, setHasProdWithNoCost] = useState(false)

  const prodWithNoCost = useMemo(() => {
    if (!loading && costRealTime) {
      const productWithNoCostMapped = cotizacion?.Lines.map((item, index) => {
        const product = costRealTime?.find(
          prod => prod?.ProductId === item?.ProductId
        )

        const newCost = product?.Cost || product?.AvgCost

        return {
          ...item,
          costoRealTime: newCost || 0,
        }
      })

      setHasProdWithNoCost(
        productWithNoCostMapped?.some(item => {
          const isService = item.IsService
          const isInstallation = isInstallationService(item)
          const isCostExempt = isCostExemptProduct(item)
          const hasNoCost = item.costoRealTime === 0

          return !isService && !isInstallation && !isCostExempt && hasNoCost
        })
      )

      return productWithNoCostMapped?.filter(item => {
        const isService = item.IsService
        const isInstallation = isInstallationService(item)
        const isCostExempt = isCostExemptProduct(item)
        const hasNoCost = item.costoRealTime === 0

        return !isService && !isInstallation && !isCostExempt && hasNoCost
      })
    }
    return []
  }, [costRealTime, cotizacion?.Lines, loading])

  const getPrices = async PriceInventoryPayload => {
    try {
      const response = await dispatch(
        getPriceInventoryGeneral(PriceInventoryPayload)
      )
      return response?.data?.Data
    } catch (error) {
      console.error(error)
    }
  }

  const fetchPriceInventory = async dispatchQtyState => {
    try {
      const PriceInventoryData = {
        CompanyId,
        CompanyCode,
        WarehouseId: warehouse,
        ProductIds: dispatchQtyState?.Lines.map(
          item => item?.ProductId || item?.productId
        ),
        UoMId: null,
      }

      const priceData = await getPrices(PriceInventoryData)
      setCostRealTime(priceData)
    } catch (error) {
      console.error('Error fetching price inventory:', error)
      throw error
    }
  }

  const getSkusNoCostProduct = () => {
    const inactiveCodes = prodWithNoCost.map(product => product.Sku)

    const skusProd = inactiveCodes.join(', ')
    return skusProd
  }

  useEffect(() => {
    if (cotizacion?.Lines?.length) {
      const updateProductCost = async () => {
        try {
          await fetchPriceInventory(cotizacion)
        } catch (error) {
          console.error(error)
        } finally {
          setLoading(false)
        }
      }
      updateProductCost()
    }
  }, [cotizacion?.Lines])

  const handlePriceChangeApprove = productLines => {
    const checkPendingPriceChange = productLines.map(product => {
      if (
        product?.NegotiatedReasonId &&
        !product?.AuthorizedPriceBy &&
        !product?.AuthorizedPriceByName
      ) {
        return {
          ...product,
          AuthorizedPriceBy: userInfo.AuthenticationInfo.UserId,
          AuthorizedPriceByName: userInfo.CustomerInfo.FullName,
        }
      }

      return product
    })

    return checkPendingPriceChange
  }

  const getUpdatedColumns = (columns, hiddenColumns, documentId) => {
    const visibleColumns =
      hiddenColumns.length > 0
        ? hiddenColumns
        : updateHiddenColumns(
            columns
              .filter(column => column.hideEnabled)
              .map(column => column.Header),
            columns
          )

    return visibleColumns.map(column => ({
      ...column,
      DocumentId: documentId,
    }))
  }

  const buildAdjustedQuote = (item, cotizacionFinal, updatedColumns) => {
    const shouldApprovePrices = item.id === docHeaderStatusId.open
    return {
      ...cotizacionFinal,
      QuoteHeader: {
        ...cotizacionFinal.QuoteHeader,
        HeaderStatusId: item.id,
        CustomerEmail:
          cotizacionFinal.QuoteHeader.EmailAddress ||
          cotizacionFinal.QuoteHeader.CustomerEmail,
        Comment: comment,
        Lines: shouldApprovePrices
          ? handlePriceChangeApprove(cotizacionFinal.QuoteHeader?.Lines)
          : cotizacionFinal.QuoteHeader?.Lines,
        TaxExempt: freeTaxes,
        AddressId:
          cotizacionFinal.QuoteHeader?.Address_AddressId ||
          cotizacionFinal.QuoteHeader?.QuoteAddressId,
        PromisedDate: promisedDate || cotizacionFinal.QuoteHeader.promisedDate,
      },
      Columns: updatedColumns,
    }
  }

  const updateQuote = (updatedQuote, action) => {
    dispatch(
      guardarCotizacion(
        updatedQuote,
        props,
        setIsErrorAddressModal,
        setMessageAddressModal,
        setSaveIsLoading,
        action
      )
    )
  }

  const asyncSave = async (item, dispatch) => {
    try {
      setOpen(false)

      setSaveIsLoading(true)

      const normalizedCotizacionFinal = {
        ...cotizacionFinal,
        QuoteHeader: {
          ...cotizacionFinal.QuoteHeader,
          Lines: cotizacionFinal.QuoteHeader?.Lines?.map(line => ({
            ...line,
            Quantity:
              line.Quantity === '' ||
              line.Quantity === null ||
              line.Quantity === undefined ||
              Number.isNaN(Number.parseFloat(line.Quantity)) ||
              Number.parseFloat(line.Quantity) <= 0
                ? 1
                : line.Quantity,
          })),
        },
      }

      const documentId = normalizedCotizacionFinal.QuoteHeader.QuoteHeaderId
      const updatedColumns = getUpdatedColumns(
        columns,
        hiddenColumns,
        documentId
      )

      const partNumberColumn = updatedColumns.find(
        column => column.ColumnName === 'Número de Parte'
      )

      const ShowPartNumber = partNumberColumn?.Status || false

      const adjustedQuote = buildAdjustedQuote(
        item,
        normalizedCotizacionFinal,
        updatedColumns
      )

      const updatedQuote = updateSellerIfApplicable(
        adjustedQuote,
        userInfo.AuthenticationInfo.UserRoles,
        userInfo.CustomerInfo
      )
      const newQuote = {
        ...updatedQuote,
        QuoteHeader: {
          ...updatedQuote.QuoteHeader,
          ShowPartNumber,
        },
      }
      if (hasOdv) {
        const response = await validatorErrorUpdate(
          hasOdv,
          newQuote,
          user,
          setIsErrorAddressModal,
          setMessageAddressModal,
          props,
          newQuote
        )

        if (response) return
        updateQuote(newQuote)
      }
      updateQuote(newQuote)
    } catch (error) {
      console.error('Error al guardar la cotización:', error)
      throw error
    }
  }

  const saveType = async (item, needReload = true) => {
    if (item.valueState !== 'CANCEL') {
      // cotizacion.PaymentTotal es el monto total pagado (misma fuente que ya
      // usa YappyPaymentInfo para mostrar el pago en pantalla).
      const yappyPayments = getYappyPayments(cotizacion?.Payments)
      const hasServerYappyPayment = yappyPayments.length > 0
      // A "Pendiente" Yappy payment (link generated this session, not yet
      // confirmed) must not block editing: editing the quote voids the link
      // and the seller must generate a new one. Only a payment confirmed by
      // the server (present in cotizacion.Payments) blocks.
      const effectivePaid = hasServerYappyPayment
        ? cotizacion?.PaymentTotal ?? 0
        : 0
      // cotizacion.AmountWithTax es una foto congelada desde la última carga
      // del servidor (setCotizacion solo se llama al hacer fetch o al cambiar
      // el cliente). El total realmente editado por el usuario vive en Redux
      // (cotizacionFinal.QuoteHeader), que es lo que asyncSave() envía al guardar.
      // Se trunca (no redondea) a 2 decimales para respetar exactamente lo pagado por el cliente.
      const truncatedTotal = Formatter.truncateNumber(
        cotizacionFinal?.QuoteHeader?.AmountWithTax ??
          cotizacion?.AmountWithTax ??
          0,
        2
      )
      const truncatedPaid = Formatter.truncateNumber(effectivePaid, 2)

      if (truncatedPaid > 0 && truncatedTotal > truncatedPaid) {
        setPaymentAmountErrorMsg({
          message: 'YAPPY_PAYMENT_INFO_T.AMOUNT_INSUFFICIENT_ERROR',
          status: 'error',
        })
        setIsPaymentAmountError(true)
        return
      }
    }

    try {
      await asyncSave(item, dispatch)
    } catch (error) {
      console.error(error)
    }
  }

  const cotizationSaveTypes = [
    {
      id: docHeaderStatusId.cancel,
      name: 'Cancelar',
      value: 'Cancelar',
      valueState: 'CANCEL',
      disabled: false,
    },
    {
      id: docHeaderStatusId.draft,
      name: 'Guardar como borrador',
      value: 'Borrador',
      valueState: 'DRAFT',
      disabled: cotizacionFinal.QuoteHeader.DocHeaderStatusAction === 'OPEN',
    },
    ...(!isCustomerUser
      ? [
          {
            id: docHeaderStatusId.open,
            name: 'Guardar documento',
            value: 'Abierto',
            valueState: 'OPEN',
            disabled:
              cotizacionFinal?.QuoteHeader?.DocHeaderStatusAction === 'OPEN'
                ? false
                : hasProdWithNoCost
                ? true
                : cotizacionFinal?.QuoteHeader?.DocHeaderStatusAction ===
                    'DRAFT' && !hasProdWithNoCost
                ? needToBeAuth && !isAuthorized
                : !isAuthorized,
          },
        ]
      : []),
  ]

  useState(() => {
    window.addEventListener('popstate', closeAllModals)
    setIsModal(false)
  }, [])

  useEffect(() => {
    if (
      !updatedColumnsVisibility &&
      columns?.length > 0 &&
      cotizacionFinal?.QuoteHeader?.Column
    ) {
      const newColumns = []
      const items = Object.keys(cotizacionFinal?.QuoteHeader?.Column[0] || {})
      items.forEach(item => {
        if (cotizacionFinal?.QuoteHeader?.Column[0][item] !== 0) {
          newColumns.push(item)
        }
      })
      const updateColumns = updateHiddenColumns(newColumns, columns)
      setHiddenColumns(updateColumns || [])
      setHiddenColumnsInitial(updateColumns || [])
      setUpdatedColumnsVisibility(true)
    }
  }, [cotizacionFinal])

  // Validación unificada para habilitar/deshabilitar botón de guardar
  useEffect(() => {
    // No comparar hasta que se cargue la cotización inicial
    if (!cotizacionInicial) {
      setActiveButton(false)
      return
    }

    // Comparar campos que se manejan con estado local
    // al detectar cambios internos de Redux que no son relevantes para el usuario
    const hasCommentChanged =
      (comment || '') !== (cotizacionInicial?.QuoteHeader?.Comment || '')
    const hasTaxExemptChanged =
      freeTaxes !== !!cotizacionInicial?.QuoteHeader?.TaxExempt
    const hasPromisedDateChanged =
      promisedDate !== cotizacionInicial?.QuoteHeader?.PromisedDate
    const hasFulfillmentPlanChanged =
      fulfillmentPlan !==
      ((cotizacionInicial?.QuoteHeader?.Lines || []).filter(
        item => item.FulfillmentPlanDescription
      )?.[0]?.FulfillmentPlanDescription ?? null)

    const hasHiddenColumnsChanged =
      JSON.stringify(hiddenColumns) !== JSON.stringify(hiddenColumnsInitial)
    const hasAgentChanged =
      agent?.SalesAgentId !== cotizacionInicial?.QuoteHeader?.SalesAgentId
    const hasCustomerCountedChanged = (() => {
      const initialQuote = cotizacionInicial?.QuoteHeader
      const currentQuote = cotizacionFinal?.QuoteHeader
      if (!validatorIsCountedCustomer(currentQuote)) return false

      const initialName = initialQuote?.CustomerNameDocument || ''
      const currentName = currentQuote?.CustomerNameDocument || ''

      const initialEmail =
        initialQuote?.CustomerEmail || initialQuote?.EmailAddress || ''
      const currentEmail =
        currentQuote?.CustomerEmail || currentQuote?.EmailAddress || ''

      const initialPhone =
        initialQuote?.Telephone ||
        initialQuote?.Telephone_Number ||
        initialQuote?.Cellphone_Number ||
        ''
      const currentPhone =
        currentQuote?.Telephone ||
        currentQuote?.Telephone_Number ||
        currentQuote?.Cellphone_Number ||
        ''

      return (
        initialName !== currentName ||
        initialEmail !== currentEmail ||
        initialPhone !== currentPhone
      )
    })()
    const hasAddressChanged = (() => {
      // Para envío a domicilio
      const initialAddressId =
        cotizacionInicial?.QuoteHeader?.QuoteAddressId ||
        cotizacionInicial?.QuoteHeader?.Address_AddressId
      const currentAddressId =
        addressInfo?.Address_AddressId ||
        addressInfo?.QuoteAddressIdCounted ||
        addressInfo?.QuoteAddressId ||
        addressInfo?.AddressId

      // Si la cotización tiene una dirección, el almacén de sus líneas no
      // representa un cambio de método de entrega y no debe compararse.
      if (initialAddressId || currentAddressId) {
        return initialAddressId !== currentAddressId
      }

      // Para retiro en sucursal
      const initialWarehouseId =
        cotizacionInicial?.QuoteHeader?.Lines?.[0]?.WarehouseId
      const currentWarehouseId =
        addressInfo?.WarehouseId || addressInfo?.Lines?.[0]?.WarehouseId

      // Detecta cambio si son diferentes y al menos uno tiene valor
      const warehouseChanged =
        initialWarehouseId !== currentWarehouseId &&
        (initialWarehouseId || currentWarehouseId)

      return warehouseChanged
    })()

    const hasChanges =
      hasCommentChanged ||
      hasTaxExemptChanged ||
      hasPromisedDateChanged ||
      hasFulfillmentPlanChanged ||
      hasHiddenColumnsChanged ||
      hasAgentChanged ||
      hasCustomerCountedChanged ||
      hasAddressChanged ||
      isDeletingProduct

    if (hasChanges && isSaveButtonAvailable) {
      setActiveButton(true)
    } else {
      setActiveButton(false)
    }
  }, [
    cotizacionFinal?.QuoteHeader,
    cotizacionInicial,
    comment,
    fulfillmentPlan,
    freeTaxes,
    promisedDate,
    hiddenColumns,
    hiddenColumnsInitial,
    agent,
    isDeletingProduct,
    isSaveButtonAvailable,
    addressInfo,
  ])

  const getArrayHiddenColumns = hiddenColumns => {
    const hiddenColumnsCopy = hiddenColumns.filter(column =>
      column.Status === false ? column.ColumnName : false
    )
    return hiddenColumnsCopy.map(column => column.ColumnName)
  }

  const handlePaymentModalClose = () => setIsPaymentModalOpen(false)

  const handlePaymentMethodConfirm = async ({ method, amount, phone }) => {
    if (method === PAYMENT_METHOD_IDS.YAPPY) {
      // cotizacion es una foto congelada desde la última carga del servidor;
      // el total mostrado en el modal prioriza cotizacionFinal.QuoteHeader (Redux),
      // así que la validación debe usar la misma fuente para no rechazar un monto
      // que el usuario ya vio como válido en pantalla.
      const quoteForYappyValidation = {
        ...cotizacion,
        AmountWithTax:
          cotizacionFinal?.QuoteHeader?.AmountWithTax ??
          cotizacion?.AmountWithTax,
      }
      const { isValid, errors } = validateQuoteForYappyPayment(
        quoteForYappyValidation
      )
      if (!isValid) {
        const message = errors[0]
        const err = new Error(message)
        err.response = { data: { Message: message } }
        throw err
      }
      try {
        await createYappyPaymentLink({
          documentId: coti?.QuoteHeaderId,
          documentTypeId: documentTypeId.QUOTATION,
          paymentTypeId: PAYMENT_METHOD_IDS.YAPPY,
          amount,
          phone,
        })
        setYappyConfirmData({ amount, phone })
        setIsYappyConfirmOpen(true)
        setLocalYappyPayment({
          payments: [
            {
              PaymentType: PAYMENT_METHOD_IDS.YAPPY,
              PaymentName: 'Yappy',
              PaymentAmount: amount,
              PaymentDate: new Date().toISOString(),
            },
          ],
          totalPayment: amount,
          statusPayment: t('YAPPY_PAYMENT_INFO_T.STATUS_PENDING'),
        })
      } catch {
        const message = t('YAPPY_PAYMENT_INFO_T.LINK_CREATION_ERROR')
        const err = new Error(message)
        err.response = { data: { Message: message } }
        throw err
      }
      return
    }
    setSelectedPaymentMethod({
      id: method,
      amount,
      label: PAYMENT_OPTIONS.find(o => o.id === method)?.label,
    })
  }

  // Change Salesman
  const [openSalesman, setOpenSalesman] = useState(false)

  const [isLoadingClone, setIsLoadingClone] = useState(false)

  const handleOpen = state => {
    setOpenSalesman(state)
  }

  const generateSalesOrder = () => {
    dispatch({
      type: 'CLEAN_SELL_ORDER',
      payload: null,
    })
    handleModalConfirmStartSalesOrder()
  }

  const handleModalConfirmStartSalesOrder = () => {
    setShowModalConfirmStartSalesOrder(!showModalConfirmStartSalesOrder)
  }

  useEffect(() => {
    if (confirmStartSalesOrder) {
      setConfirmStartSalesOrder(false)
      handleModalGenerateSalesOrder()
    }
  }, [confirmStartSalesOrder])

  const handleModalGenerateSalesOrder = () => {
    setShowModalGenerateSalesOrder(!showModalGenerateSalesOrder)
  }

  const processSalesOrder = values => {
    const isCreditCommercial = values?.credit === 'yes'
    const creditAccountId = values?.accountItemSelected?.CreditAccountId

    if (
      odvCreditAccount &&
      isCreditCommercial &&
      creditAccountId &&
      creditAccountId !== odvCreditAccount.CreditAccountId
    ) {
      setShowModalGenerateSalesOrder(false)
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.CREDIT_ACCOUNT_LOCKED'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    if (
      isCreditCommercial &&
      (!creditAccountId || creditAccountId === EMPTY_GUID)
    ) {
      setShowModalGenerateSalesOrder(false)
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.INVALID_CREDIT_ACCOUNT'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    dispatch({ type: 'SELL_ORDER_FILE_ATTACHED', payload: values.file })
    dispatch({ type: 'IS_COMMERCIAL_CREDIT_SELECTED', payload: values })
    history.push(ROUTES.salePreorder)
  }

  const checkStatusProductsApproved = bool => {
    indexProductCurrent === productsChanged.length - 1 &&
      setShowModalPriceChangeApproval(false)
    if (bool) {
      const approvedLines = lines.map(line => {
        if (line.ProductId === productsChanged[indexProductCurrent].ProductId) {
          line.AuthorizedPriceBy = userId
          line.AuthorizedPriceByName = userName
          line.Price =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.Price
              : line.Price
          line.Amount =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.Amount
              : line.Amount
          line.AmountWithTax =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.AmountWithTax
              : line.AmountWithTax
          line.DiscountAmount =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.DiscountAmount
              : line.DiscountAmount
          line.DiscountAmountLocal =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.DiscountAmountLocal
              : line.DiscountAmountLocal
          line.DiscountPct =
            newPriceProductCurrent !== null
              ? newPriceProductCurrent?.DiscountPct
              : line.DiscountPct
        }
        return line
      })
      // remove product from productsChanged
      const newProductsChanged = productsChanged.filter(
        product =>
          product.ProductId !== productsChanged[indexProductCurrent].ProductId
      )
      setProductsChanged(newProductsChanged)
      setNewPriceProductCurrent(null)
      dispatch(
        cotizacionPriceChangeApproval({
          Lines: approvedLines,
        })
      )
      setShowModalApprovedPrice(true)
      // set setShowModalApprovedPrice to false after 2 seconds
      setTimeout(() => {
        setShowModalApprovedPrice(false)
        setActiveButton(true)
      }, 2000)
    } else {
      setIndexProductCurrent(indexProductCurrent + 1)
      setShowModalRejectedPrice(true)
      // set setShowModalRejectedPrice to false after 2 seconds
      setTimeout(() => {
        setShowModalRejectedPrice(false)
      }, 2000)
    }
  }

  const handleChangePriceProduct = value => {
    if (value === '' || value === undefined || value === null) {
      return
    }
    const Price = parseFloat(value)
    const AmountWithTax =
      productsChanged[indexProductCurrent].Quantity *
      (Price * productsChanged[indexProductCurrent].TaxCategoryValue + Price)
    const Amount = productsChanged[indexProductCurrent].Quantity * Price
    const DiscountAmount =
      productsChanged[indexProductCurrent].BasePrice - Price < 0
        ? 0
        : productsChanged[indexProductCurrent].Quantity *
          (productsChanged[indexProductCurrent].BasePrice - Price)
    const DiscountPct =
      ((productsChanged[indexProductCurrent].BasePrice - Price) * 100) / Price <
      0
        ? 0
        : ((productsChanged[indexProductCurrent].BasePrice - Price) * 100) /
          Price
    const newProduct = {
      ...productsChanged[indexProductCurrent],
      Price,
      Amount,
      AmountWithTax,
      DiscountAmount,
      DiscountAmountLocal: DiscountAmount,
      DiscountPct,
    }
    setNewPriceProductCurrent(newProduct)
  }

  const validateSalesOrderAvaliability = () => {
    let isSaleOrderNotAvaliable = false

    if (coti.DocHeaderStatusDescription !== docHeaderStatusDescription.open) {
      isSaleOrderNotAvaliable = true
    }

    return isSaleOrderNotAvaliable
  }
  const handleClose = (needUpdate = false) => {
    setIsModal(false)
    setShowModalEditClient(false)
    setChange(false)
    needUpdate && fetchCotizacion()
  }

  const renderEditQoutationComponent = () => {
    const isDocumentCanceledOrClosed =
      cotizacion?.DocHeaderStatusDescription ===
        docHeaderStatusDescription.canceled ||
      cotizacion?.DocHeaderStatusDescription ===
        docHeaderStatusDescription.closed

    // Filtered by Yappy payments specifically (not "any payment exists"): a
    // payment with another method (e.g. the "Pendiente Pago" placeholder from
    // web checkout) must not be shown as if it were Yappy.
    const hasServerPayments = getYappyPayments(cotizacion?.Payments).length > 0
    // PaymentStatus llega poblado ("Pendiente") desde que se crea el link de
    // pago, antes de que exista una entrada confirmada en Payments; ya no se
    // depende de PaymentUrl (no siempre llega, p.ej. en órdenes de venta).
    const showYappyInfo =
      hasServerPayments ||
      localYappyPayment != null ||
      Boolean(cotizacion?.PaymentStatus)
    // There's a server-side payment that isn't Yappy (e.g. the "Pendiente
    // Pago" placeholder): a method is already assigned, so it's wrong to ask
    // the user to "select a payment method" or to show it as Yappy.
    const hasNonYappyPayment =
      !showYappyInfo && (cotizacion?.Payments?.length ?? 0) > 0

    return (
      <>
        {isLoadingClone && <Loading full />}
        {cotizacion && date && (
          <div
            className="cotizacion-generada-container"
            data-testid="container-edit-quotation">
            <div
              className="cotizacion-generada"
              data-testid="container-generated-quotation">
              <div
                className="cotizacion-editar-header"
                data-testid="container-quotation-header">
                {isCreate ? (
                  <p className="titulo-cotizacion cotizacion-alerta">
                    Se ha generado tu cotización número:{' '}
                    {cotizacion.DocumentNumber}
                  </p>
                ) : (
                  <div
                    className="titulo-cotizacion cotizacion-alert"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}>
                    <span>Cotización número: {cotizacion.DocumentNumber}</span>
                    <LightTooltip
                      title="Clonar cotización"
                      placement="right"
                      arrow={true}>
                      <button
                        data-testid="btn-clone-quote"
                        onClick={() => setshowModalClone(true)}
                        className="clonar-icon-button"
                        style={{
                          backgroundColor: '#f0f0f0',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '5px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                        <img
                          src={duplicateBlue}
                          alt="duplicate"
                          style={{
                            cursor: 'pointer',
                          }}
                        />
                      </button>
                    </LightTooltip>
                  </div>
                )}
              </div>
              <div
                className="info-general"
                data-testid="container-info-general">
                <div
                  className="info-general-cliente"
                  data-testid="container-client-info">
                  {cotizacion?.CustomerId &&
                  !validatorIsCountedCustomer(cotizacion) ? (
                    <>
                      <p>
                        Cliente:{' '}
                        {cotizacion?.CustomerNameDocument ||
                          cotizacion?.CustomerFullName ||
                          'Sin Información'}
                      </p>
                      {editClienteContado && (
                        <input
                          data-testid="input-client-name"
                          type="text"
                          name="cliente-contado"
                          placeholder="Ingresa el nombre del cliente"
                        />
                      )}
                      <p>
                        {/* cliente.CustomerInfo.Email */}
                        Email: {email || 'Sin Información'}
                      </p>
                      <p>
                        Teléfono:{' '}
                        {cotizacion?.Cellphone_Number ||
                          cotizacion?.Telephone_Number ||
                          'Sin Información'}
                      </p>
                    </>
                  ) : (
                    <>
                      {!editClienteContado && (
                        <div>
                          <p>
                            Cliente:{' '}
                            <span>
                              {cotizacion.CustomerNameDocument ||
                                'Sin Información'}
                            </span>
                          </p>
                          <p>
                            Email:{' '}
                            {cotizacion.CustomerEmail ||
                              cotizacion.EmailAddress ||
                              'Sin Información'}
                          </p>
                          <p>
                            Teléfono:{' '}
                            {cotizacion?.Telephone ||
                              cotizacion.Telephone_Number ||
                              cotizacion.Cellphone_Number ||
                              'Sin Información'}
                          </p>
                        </div>
                      )}
                      {editClienteContado && (
                        <>
                          <p className="cliente-contado-edit-box">
                            <span className="cliente-contado-edit">
                              <input
                                data-testid="input-cash-client-name"
                                className="edit-contado"
                                type="text"
                                name="cliente-contado"
                                onChange={e =>
                                  setClienteTemp({
                                    ...clienteTemp,
                                    name: e.target.value,
                                  })
                                }
                                value={clienteTemp.name ?? ''}
                                placeholder={cotizacion.CustomerNameDocument}
                              />
                              <p className="field-required-camp">
                                {t(errorCustomerCounted.names)}
                              </p>
                            </span>
                          </p>
                          <p className="cliente-contado-edit-box">
                            <span className="cliente-contado-edit">
                              <input
                                data-testid="input-cash-client-email"
                                className="edit-contado"
                                type="text"
                                name="cliente-contado"
                                onChange={e =>
                                  setClienteTemp({
                                    ...clienteTemp,
                                    email: e.target.value,
                                  })
                                }
                                placeholder={
                                  cotizacion.EmailAddress ||
                                  cotizacion.CustomerEmail ||
                                  'Correo electrónico (opcional)'
                                }
                                value={clienteTemp.email}
                              />
                              <p className="field-required-camp">
                                {t(errorCustomerCounted.email)}
                              </p>
                            </span>
                          </p>
                          <p className="cliente-contado-edit-box">
                            <span className="cliente-contado-edit">
                              <input
                                data-testid="input-cash-client-phone"
                                className="edit-contado"
                                type="text"
                                name="cliente-contado"
                                onChange={e => {
                                  const value = e.target.value
                                    .replace(/\D/g, '')
                                    .slice(0, 8)
                                  setClienteTemp({
                                    ...clienteTemp,
                                    telephone: value,
                                  })
                                }}
                                value={clienteTemp.telephone}
                                placeholder={
                                  cotizacion.Cellphone_Number ||
                                  cotizacion.Telephone_Number ||
                                  'Teléfono (opcional)'
                                }
                              />
                              <p className="field-required-camp">
                                {t(errorCustomerCounted.phone)}
                              </p>
                            </span>
                          </p>
                          <div
                            className="edit-contado-buttons"
                            data-testid="container-edit-client-buttons">
                            <Check
                              data-testid="btn-confirm-cash-client"
                              onClick={validationError}
                            />
                            <X
                              data-testid="btn-cancel-cash-client"
                              onClick={handleClienteContado}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {cotizacion.DocHeaderStatusDescription !==
                    docHeaderStatusDescription.canceled &&
                  cotizacion.DocHeaderStatusDescription !==
                    docHeaderStatusDescription.closed &&
                  !isCustomer &&
                  !editClienteContado ? (
                    <FontAwesomeIcon
                      data-testid="edit-client-icon"
                      icon={faSquarePen}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          customerId &&
                          !validatorIsCountedCustomer(cotizacion)
                        ) {
                          if (change && activeButton) {
                            setShowHasChangesModal(true)
                            setIsModal(false)
                          } else handleModal()
                        } else {
                          setEditClienteContado(true)
                        }
                      }}
                    />
                  ) : null}
                </div>
                <div
                  className="info-general-retiro"
                  data-testid="container-delivery-info">
                  {addressInfo?.QuoteAddressIdCounted ||
                  addressInfo?.AddressId ? (
                    <>
                      <p>Envío a domicilio</p>
                      <p>
                        {t('Address', {
                          value:
                            addressInfo?.QuoteAddressStreet ||
                            addressInfo?.QuoteAddressDetail ||
                            addressInfo?.Address_Street ||
                            addressInfo?.Address_AddressDetail ||
                            addressInfo?.AddressDetail ||
                            t('whithoutDatail'),
                        })}
                      </p>
                      <p>
                        {addressInfo?.CustomerAddress ||
                          `${
                            addressInfo?.Address_CountryName ||
                            addressInfo?.CountryName
                          }, ${
                            addressInfo?.Address_ProvinceName ||
                            addressInfo?.ProvinceName
                          }, ${
                            addressInfo?.Address_DistrictName ||
                            addressInfo?.DistrictName
                          }, ${
                            addressInfo?.Address_TownshipName ||
                            addressInfo?.TownshipName
                          }`}
                      </p>
                      <p>
                        {t('Alias', {
                          value:
                            cotizacion?.Origin === 'AB'
                              ? addressInfo?.Address_AddressName ||
                                addressInfo?.Name ||
                                t('whithoutDatail')
                              : addressInfo?.Address_AddressName ||
                                addressInfo?.Name ||
                                addressInfo?.Address_AddressDetail ||
                                t('whithoutDatail'),
                        })}
                      </p>
                      <p>
                        {t('Phone', {
                          value:
                            addressInfo?.Address_PhoneNumber ||
                            addressInfo?.PhoneNumber ||
                            t('whithoutDatail'),
                        })}
                      </p>
                      <DeliveryDateLabel
                        date={promisedDate ?? addressInfo?.PromisedDate}
                        variant="delivery"
                      />
                    </>
                  ) : (
                    <>
                      <p>Retiro en sucursal</p>
                      <p>{warehouseInfo?.Lines?.[0]?.WarehouseAddress}</p>
                      <p>{warehouseInfo?.Lines?.[0]?.WarehouseDescription}</p>
                      <p>{warehouseInfo?.Lines?.[0]?.WarehouseCode}</p>
                      <p>{warehouseInfo?.Telephone_Number}</p>
                      <DeliveryDateLabel
                        date={promisedDate ?? addressInfo?.PromisedDate}
                        variant="pickup"
                      />
                    </>
                  )}
                  {fulfillmentPlan && <p>Plan de entrega: {fulfillmentPlan}</p>}
                  {cotizacion.DocHeaderStatusDescription !==
                    docHeaderStatusDescription.canceled &&
                  cotizacion.DocHeaderStatusDescription !==
                    docHeaderStatusDescription.closed ? (
                    <FontAwesomeIcon
                      data-testid="edit-delivery-icon"
                      icon={faSquarePen}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        // Guardar valores originales antes de abrir el modal
                        originalDeliveryDataRef.current = {
                          addressInfo,
                          promisedDate,
                        }
                        setIsModal(true)
                        window.history.pushState(
                          { id: 1 },
                          null,
                          '?q=open-client-modal'
                        )
                        setShowModalEditDelivery(true)
                      }}
                    />
                  ) : null}
                </div>
                <div
                  className="info-general-vendedor"
                  data-testid="container-seller-info">
                  <FontAwesomeIcon
                    data-testid="edit-seller-icon"
                    icon={faSquarePen}
                    onClick={() => handleOpen(true)}
                    style={{
                      display: canChangeSeller ? 'block' : 'none',
                      cursor: 'pointer',
                    }}
                  />
                  <p>Vendedor: {agent.SalesAgentFullName}</p>
                  <p>Fecha: {FormatedDate(cotizacion.CreatedDate)}</p>
                  <p>Cotización: {cotizacion.DocumentNumber}</p>
                  <p>Canal utilizado: {cotizacion.Channel}</p>
                  <div
                    className="cotizacion-labels"
                    data-testid="container-quotation-labels">
                    <p
                      className="status"
                      style={{
                        backgroundColor: generateColorStatus(
                          cotizacion.DocHeaderStatusDescription,
                          pendingStatusDocument,
                          processStatusDocument,
                          closeStatusDocument,
                          expiredStatusDocument,
                          colorsStatus
                        ),
                      }}>
                      {cotizacion.DocHeaderStatusDescription}
                    </p>
                    {hasChangePriceApprove(coti.Lines) &&
                      !(
                        isComercialSellerConstruction ||
                        isComercialSellerDistribution
                      ) && (
                        <p className="status-pending">
                          Aprobación de precio pendiente
                        </p>
                      )}
                  </div>
                </div>
                <div
                  className="info-general-codigo-qr"
                  data-testid="container-qr-code">
                  <img src={qrSource} alt="QR" data-testid="img-qr-code" />
                </div>
              </div>
              {hasProdWithNoCost ? (
                <div className="sell-order-product-advice">
                  <p>
                    <span className="info-advice-text-title">Nota: </span>
                    No se puede generar una cotización con productos de costo
                    cero ({getSkusNoCostProduct()}). Por favor, revisa los
                    costos con compras antes de continuar.
                  </p>
                </div>
              ) : null}
              <FilteringTable
                data={productsData}
                isDetailQuote
                prodWithNoCost={prodWithNoCost}
                columns={columns}
                showMargin={showAll}
                isProductPage={true}
                hasButtons={hasButtons}
                visibleIcons={visibleIcons}
                setHiddenColumns={setHiddenColumns}
                hiddenColumns={getArrayHiddenColumns(hiddenColumns)}
                hiddenColumnDiscount={hiddenColumnDiscount}
                handleCartEdit={(product, index) =>
                  handleCartEdit(product, index)
                }
                handleCartPopulation={() => handleCartPopulation()}
                generateSalesOrder={generateSalesOrder}
                isPriceNotApproved={validateSalesOrderAvaliability()}
                // change the value here for show or hidde sales order button
                isSaleOrderGenerated={
                  cotizacion.DocHeaderStatusId !== docHeaderStatusId.draft &&
                  !cotizacion.RelationDoc?.some(
                    docs =>
                      docs?.DocumentNumber.includes('ODV') ||
                      docs?.DocumentTypeId?.toLowerCase().includes(
                        documentTypeId?.ODV?.toLowerCase()
                      )
                  ) &&
                  cotizacion.Origin !== 'AB'
                }
                isDispatchGenerated={
                  cotizacion.DocHeaderStatusId !== docHeaderStatusId.draft &&
                  !cotizacion.RelationDoc?.some(docs =>
                    docs.DocumentNumber.includes('SD')
                  )
                }
                top
                topButtons={
                  <TopButtons
                    pdf={downloadPdf}
                    sendEmail={sendEmail}
                    needToBeAuth={needToBeAuth}
                    handlePriceChange={openPriceChangeModal}
                    lines={lines}
                    isAuthorized={isAuthorized}
                    hasProducts={productsChanged.length > 0}
                    companyId={cotizacion?.CompanyId}
                  />
                }
                hideFooter={null}
                isInventory={null}
                showDiscountOption={showDiscountOption}
                leftFooterContent={
                  <>
                    <MarginText />
                    {showYappyInfo ? (
                      <YappyPaymentInfo
                        className="yappy-payment-info--spaced"
                        payments={
                          hasServerPayments
                            ? cotizacion.Payments
                            : localYappyPayment?.payments
                        }
                        totalPayment={
                          (hasServerPayments
                            ? cotizacion.PaymentTotal
                            : localYappyPayment?.totalPayment ??
                              cotizacion?.PaymentAmounPay) ??
                          cotizacionFinal?.QuoteHeader?.AmountWithTax ??
                          cotizacion?.AmountWithTax
                        }
                        statusPayment={
                          cotizacion?.PaymentStatus ??
                          localYappyPayment?.statusPayment
                        }
                      />
                    ) : hasNonYappyPayment ? (
                      <>
                        <p style={{ fontSize: '14px', fontWeight: '600' }}>
                          {t('PAYMENT_METHOD_SECTION_T.TITLE')}
                        </p>
                        <ListPaymentTypes payments={cotizacion.Payments} />
                      </>
                    ) : (
                      canSelectPaymentMethod && (
                        <PaymentMethodSection
                          onOpenModal={() => setIsPaymentModalOpen(true)}
                          selectedMethod={selectedPaymentMethod}
                        />
                      )
                    )}
                  </>
                }
              />
            </div>
            <AdditionalServiceDetailsEditor readOnly={true} />
            <div
              className="cotizacion-generada-nota"
              data-testid="container-quotation-note">
              <h2>Nota</h2>
              <p>
                Esta cotización es válida únicamente por 15 días; la
                disponibilidad de los productos aquí mostrados, podrán variar
                durante estos 15 días. Los precios de oferta incluidos en la
                cotización se regirán por las fechas establecidas de la
                promoción.
              </p>
            </div>
            <div
              className="cotizacion-generada-documento"
              data-testid="container-document-comment">
              <div data-testid="container-attach-document">
                <h2 style={{ fontSize: '16px' }}>Adjuntar documento</h2>
                <div className="adjuntar">
                  <label
                    data-testid="label-file-upload"
                    htmlFor="cotizacion-file-upload">
                    <BoxArrowUp /> Examinar
                  </label>
                  <input
                    id="cotizacion-file-upload"
                    type="file"
                    data-testid="input-file-upload"
                  />
                </div>
              </div>
              <div data-testid="container-add-comment">
                <h2 style={{ fontSize: '16px' }}>Agregar comentario</h2>
                <textarea
                  data-testid="comment-textarea"
                  maxLength={5000}
                  value={comment || ''}
                  disabled={isDocumentCanceledOrClosed}
                  onChange={e => setComment(e.target.value)}
                />
              </div>
              <div data-testid="container-related-documents">
                <div style={{ fontSize: '14px' }}>
                  {cotizacion?.RelationDoc &&
                    cotizacion?.RelationDoc?.length > 0 && (
                      <>
                        <div
                          className="footer-left-text-title row"
                          style={{
                            fontSize: '1.4rem',
                          }}>
                          {t('DISPATCH_ORDER_T.RELATED_DOCS')}
                        </div>
                        {cotizacion?.RelationDoc?.map((item, index) => {
                          return (
                            <Row className="footer-left-text" key={index}>
                              <RelationalDocLabel
                                dataODC={dataODC}
                                value={item}
                                document={cotizacion}
                              />
                            </Row>
                          )
                        })}
                      </>
                    )}
                </div>
              </div>
            </div>
            <div
              className="cotizacion-save-button"
              data-testid="container-save-button">
              <LightTooltip
                title={cotizationSaveTypes.map((item, index) => {
                  return (
                    <button
                      key={index}
                      data-testid={`btn-save-option-${item.id || index}`}
                      disabled={item.disabled}
                      className="products-cart-button-tooltip"
                      onClick={() => saveType(item)}>
                      {item.name}
                    </button>
                  )
                })}
                PopperProps={{
                  disablePortal: true,
                }}
                placement="top"
                arrow={true}
                open={open}
                onClose={handleTooltipClose}
                disableFocusListener
                disableTouchListener>
                <button
                  data-testid="btn-save-quotation"
                  onClick={() => {
                    setOpen(true)
                  }}
                  style={{ display: hasButtons }}
                  className={
                    !activeButton ? 'guardar_button_disabled' : 'guardar_button'
                  }
                  disabled={!activeButton}>
                  {saveIsLoading ? (
                    <CircularProgress
                      sx={{
                        '& .MuiCircularProgress-svg': { color: '#FFFFFF' },
                      }}
                      size="2rem"
                    />
                  ) : (
                    'Guardar'
                  )}
                </button>
              </LightTooltip>
            </div>
          </div>
        )}

        <Modal open={showModalEditDelivery} data-testid="modal-edit-delivery">
          <Box>
            <div
              className="delivery-info-container"
              data-testid="container-modal-edit-delivery"
              style={{
                position: 'relative',
                height: '94vh',
                overflowY: 'scroll',
              }}>
              <img
                data-testid="btn-close-modal-delivery"
                style={{
                  position: 'absolute',
                  top: '40px',
                  right: '50px',
                }}
                src={No}
                alt="close"
                onClick={() => {
                  // Restaurar valores originales al cerrar sin guardar
                  if (originalDeliveryDataRef.current) {
                    setAddressInfo(originalDeliveryDataRef.current.addressInfo)
                    setPromisedDate(
                      originalDeliveryDataRef.current.promisedDate
                    )
                    originalDeliveryDataRef.current = null
                  }
                  window.history.back()
                  setIsModal(false)
                  setShowModalEditDelivery(false)
                  setChange(true)
                }}
              />
              <MetodoEntrega
                setSelectedAddress={setAddressInfo}
                selectedAddress={addressInfo}
                setDireccion={setDireccion}
                onCloseMetodoEntrega={handleDelivery}
                setPromisedDate={setPromisedDate}
                promisedDate={promisedDate}
                isEditMode={true}
                autoClose={false}
              />
            </div>
          </Box>
        </Modal>

        {/* aceptar cambios de precios */}
        <Modal
          open={showModalPriceChangeApproval}
          data-testid="modal-price-change">
          <Box
            className="modal-box"
            style={{
              height: 'auto',
            }}>
            <div
              className="restore-container"
              data-testid="container-modal-price-change">
              <div className="modal-header-restore">
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }}>
                  Solicitud de cambio de precios
                </p>
                <img
                  data-testid="btn-close-modal-price"
                  src={No}
                  alt="close"
                  onClick={() => {
                    setShowModalPriceChangeApproval(false)
                  }}
                />
              </div>
              <div
                style={{
                  paddingLeft: '9px',
                  paddingRight: '9px',
                }}>
                <div>
                  <p
                    style={{
                      fontSize: '16px',
                    }}>
                    Vendedor: {agent?.SalesAgentFullName}
                  </p>
                  <p>
                    {fulfillmentPlan === fullfilmentDescription ? (
                      <p
                        style={{
                          fontSize: '16px',
                        }}>
                        {coti?.Address_Street} - {coti?.Address_AddressDetail}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: '16px',
                        }}>
                        {cotizacion?.Lines?.[0]?.WarehouseDescription}
                      </p>
                    )}
                  </p>
                </div>
                {productsChanged &&
                  productsChanged[indexProductCurrent] &&
                  productsChanged.length > 0 && (
                    <div>
                      <div
                        className="price-change-approval"
                        style={{ marginTop: '24px' }}>
                        <div className="price-change-approval-item">
                          <div className="image">
                            <img
                              src={
                                productsChanged?.[indexProductCurrent]
                                  ?.DefaultProductPicture ?? NoImage
                              }
                              alt="product-img"
                              style={{ maxWidth: '100px' }}
                            />
                          </div>
                          <div className="info">
                            <p className="name">
                              {productsChanged[indexProductCurrent].ProductName}
                            </p>
                            <p>{productsChanged[indexProductCurrent].Sku}</p>
                            <p
                              style={{
                                fontWeight: 'bold',
                              }}>
                              {productsChanged[indexProductCurrent]
                                .FinalPrice &&
                              productsChanged[indexProductCurrent].FinalPrice <
                                productsChanged[indexProductCurrent].BasePrice
                                ? '$' +
                                  productsChanged[indexProductCurrent]
                                    .FinalPrice
                                : '$' +
                                  productsChanged[indexProductCurrent]
                                    .BasePrice}
                            </p>
                          </div>
                        </div>
                      </div>
                      <button className="approval-price-button-modal disabled">
                        {productsChanged[indexProductCurrent].NegotiatedReason}
                      </button>
                      <div>
                        <p
                          style={{
                            fontSize: '16px',
                          }}>
                          Precio de negociación
                        </p>
                      </div>
                      <CurrencyInput
                        data-testid="input-negotiation-price"
                        aria-label="price"
                        aria-describedby="price-sign"
                        placeholder={
                          '$' + productsChanged[indexProductCurrent].Price
                        }
                        name="precioNuevo"
                        className="input-price"
                        decimalsLimit={2}
                        onValueChange={value => handleChangePriceProduct(value)}
                      />
                      <div className="button-list mt-4">
                        <button
                          data-testid="btn-reject-price"
                          className="approval-price-button-modal"
                          onClick={() => {
                            checkStatusProductsApproved(false)
                          }}>
                          No aprobar precio
                        </button>
                        <button
                          data-testid="btn-approve-price"
                          className="approval-price-button-modal active"
                          onClick={() => {
                            checkStatusProductsApproved(true)
                          }}>
                          Aprobar precio
                        </button>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </Box>
        </Modal>

        {/* EDITAR CLIENTE */}
        <Modal open={showModalEditClient} data-testid="modal-edit-client">
          <Box className="modal-box-client">
            <div
              className="restore-container"
              data-testid="container-modal-edit-client">
              <div className="modal-header-restore">
                <h2>Editar cliente</h2>
                <img
                  data-testid="btn-close-modal-client"
                  src={No}
                  alt="close"
                  onClick={() => handleClose(false)}
                />
              </div>
              <CrearCliente
                handleClose={() => handleClose(true)}
                needAutoclose
              />
            </div>
          </Box>
        </Modal>

        {/* ELIMINAR PRODUCTO */}
        <Modal
          open={showModalEliminarProduct}
          data-testid="modal-delete-product">
          <Box className="modal-box">
            <div className="closing-button modal-cotizacion">
              <img
                data-testid="btn-close-modal-delete-product"
                src={No}
                onClick={() => setShowModalEliminarProduct(false)}
                alt="close"
              />
            </div>
            <div
              className="modal-content-text"
              data-testid="container-deleted-product-message">
              <img
                src={CheckIcon}
                alt="check"
                style={{
                  width: '46px',
                  height: '46px',
                  marginBottom: 9,
                }}
              />
              <h2>El producto ha sido eliminado exitosamente</h2>
            </div>
          </Box>
        </Modal>

        {/* modal email  */}
        <Modal open={showModalEmail} data-testid="modal-send-email">
          <Box className="modal-box">
            <div
              className="restore-container"
              data-testid="container-modal-send-email">
              <div className="modal-header-restore">
                <h2>Enviar cotización</h2>
                <span
                  data-testid="btn-close-modal-send-email"
                  onClick={() => {
                    formik.setErrors({})
                    setShowModalEmail(false)
                  }}
                  className="close-modal">
                  <img src={No} alt="close" />
                </span>
              </div>
              <form
                onSubmit={formik.handleSubmit}
                data-testid="form-send-email">
                <div>
                  <input
                    data-testid="input-send-email"
                    type="email"
                    name="email"
                    placeholder="Ingresa tu correo electrónico"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div
                      style={{ marginTop: '5px' }}
                      className="input-feedback">
                      <strong>{formik.errors.email}</strong>
                    </div>
                  ) : null}
                  {showMessageEmail && (
                    <div
                      className="alert alert-success mt-2"
                      role="alert"
                      data-testid="alert-email-sent">
                      <strong>Correo enviado exitosamente</strong>
                    </div>
                  )}

                  <div className="modal-buttons">
                    <button
                      data-testid="btn-cancel-send-email"
                      type="button"
                      onClick={() => {
                        formik.setErrors({})
                        setShowModalEmail(false)
                      }}
                      className="btn modal-cancel">
                      Cancelar
                    </button>
                    <button
                      data-testid="btn-send-email"
                      type="submit"
                      className="btn modal-continue">
                      {loadingSendEmail ? (
                        <FontAwesomeIcon icon={faSpinner} className="spinner" />
                      ) : (
                        'Enviar'
                      )}
                    </button>
                  </div>
                  {/* AGREGAR UN ALERT */}
                </div>
              </form>
            </div>
          </Box>
        </Modal>

        {/* Modal confirmar iniciar orden de venta */}
        <Modal
          open={showModalConfirmStartSalesOrder}
          data-testid="modal-confirm-sales-order">
          <Box>
            <ConfirmStartSalesOrder
              setShowModalConfirmStartSalesOrder={
                handleModalConfirmStartSalesOrder
              }
              setConfirmStartSalesOrder={setConfirmStartSalesOrder}
              processSalesOrder={processSalesOrder}
            />
          </Box>
        </Modal>

        {/* Modal generar orden de venta */}
        <Modal
          open={showModalGenerateSalesOrder}
          data-testid="modal-generate-sales-order">
          <Box>
            <GenerateSalesOrder
              setShowModalGenerateSalesOrder={handleModalGenerateSalesOrder}
              processSalesOrder={processSalesOrder}
              originalCreditAccount={odvCreditAccount}
            />
          </Box>
        </Modal>

        <Modal
          open={showModalApprovedPrice}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          data-testid="modal-price-approved">
          <Box className="modal-box-message">
            <div
              className="modal-box-channel-message"
              data-testid="container-price-approved-message">
              <div className="closing-button">
                <img
                  data-testid="btn-close-modal-price-approved"
                  src={No}
                  onClick={() => setShowModalApprovedPrice(false)}
                  alt="close"
                />
              </div>
              <div className="modal-box-channel-message-content">
                <img src={CheckIcon} alt="check" />
                <h2>
                  El precio ha sido
                  <br />
                  cambiado exitosamente
                </h2>
              </div>
            </div>
          </Box>
        </Modal>

        <Modal
          open={showFailMessageModal}
          onClose={() => {
            setShowFailMessageModal(false)
          }}
          data-testid="modal-save-error">
          <Box>
            <GenericModal
              hideCheck={true}
              showCaution={true}
              mostrarButtons={false}
              setConfirm={() => setShowFailMessageModal(false)}
              setIsOpen={() => setShowFailMessageModal(false)}
              text={t('GENERIC_MODAL.ERROR_SAVING_QUOTATION')}></GenericModal>
          </Box>
        </Modal>

        <Modal
          open={showModalRejectedPrice}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          data-testid="modal-price-rejected">
          <Box className="modal-box-message">
            <div
              className="modal-box-channel-message"
              data-testid="container-price-rejected-message">
              <div className="closing-button">
                <img
                  data-testid="btn-close-modal-price-rejected"
                  src={No}
                  onClick={() => setShowModalRejectedPrice(false)}
                  alt="close"
                />
              </div>
              <div className="modal-box-channel-message-content">
                <img src={CheckIcon} alt="check" />
                <h2>
                  La solicitu de cambio de precio
                  <br />
                  no fue aprobada
                </h2>
              </div>
            </div>
          </Box>
        </Modal>

        <ModalAlertGeneric
          isError={isErrorAddressModal}
          setIsError={setIsErrorAddressModal}
          messageSettings={messageAddressModal}
          setMessageSettings={setMessageAddressModal}
        />

        <ChangeSalesman
          handleOpen={handleOpen}
          open={openSalesman}
          setAgent={setAgent}
        />
        <ModalQuoteCloneAlert
          showModalClone={showModalClone}
          setshowModalClone={setshowModalClone}
          quote={cotizacion}
          setIsLoadingClone={setIsLoadingClone}
          checkFinalPrice={checkFinalPrice}
          history={history}
        />
        {canSelectPaymentMethod && (
          <>
            <PaymentMethodModal
              open={isPaymentModalOpen}
              onClose={handlePaymentModalClose}
              totalAmount={
                cotizacionFinal?.QuoteHeader?.AmountWithTax ??
                cotizacion?.AmountWithTax
              }
              phone={
                cotizacion?.Telephone ||
                cotizacion?.Telephone_Number ||
                cotizacion?.Cellphone_Number
              }
              onConfirm={handlePaymentMethodConfirm}
              yappyEnabled={yappyEnabled}
              isCheckingYappy={isCheckingYappy}
            />
            <YappyPaymentConfirmationModal
              open={isYappyConfirmOpen}
              onClose={() => setIsYappyConfirmOpen(false)}
              clientName={cotizacion?.CustomerNameDocument}
              email={cotizacion?.CustomerEmail || cotizacion?.EmailAddress}
              phone={yappyConfirmData?.phone}
              amount={yappyConfirmData?.amount}
            />
          </>
        )}
        <ModalAlertGeneric
          isError={isPaymentAmountError}
          setIsError={setIsPaymentAmountError}
          messageSettings={paymentAmountErrorMsg}
          setMessageSettings={setPaymentAmountErrorMsg}
          isButtonClose
        />
      </>
    )
  }

  return (
    <>
      {isEditLoading && <Loading full />}
      {window.location.search.length === 0 && (
        <RouterPrompt
          show={change && !isModal}
          showWithoutNavigation={showHasChangesModal && activeButton}
          setShowHasChangesModal={setShowHasChangesModal}
          title="¿Quieres guardar los cambios efectuados en la cotización?"
          cancelText="No"
          okText="Si"
          onOK={() => true}
          onCancel={() => false}
          handleSave={saveCotizacion}
          address={addressInfo}
        />
      )}
      <Navigation />
      {loading ? (
        <MiniLoading full={true} noMargin={true} />
      ) : (
        renderEditQoutationComponent()
      )}
    </>
  )
}

export default EditarCotizacion
